import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navLinks, siteName } from '@/mocks/melons';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled ? 'border-background-200 bg-background-50/95 shadow-[0_1px_0_0_oklch(var(--background-200))] backdrop-blur' : 'border-background-200 bg-background-50'
      }`}
    >
      <div className="container-page flex h-16 items-center justify-between gap-4 md:h-[72px]">
        <a href="/" className="flex shrink-0 items-center gap-2.5" aria-label={siteName}>
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-600 font-heading text-xl font-black text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">快手吃瓜</span>
            <span className="mt-1 hidden text-[11px] text-foreground-600 sm:block">瓜料大全 · 瓜田盘点</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) =>
            l.href === '/about' ? (
              <Link
                key={l.label}
                to="/about"
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.label}
                href={l.href}
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ),
          )}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/#hot"
            className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 sm:inline-flex"
          >
            <i className="ri-fire-line" aria-hidden="true" />
            今日瓜讯
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-100 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="container-page flex flex-col gap-1 py-3" aria-label="移动端导航">
            {navLinks.map((l) =>
              l.href === '/about' ? (
                <Link
                  key={l.label}
                  to="/about"
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-[15px] font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-[15px] font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {l.label}
                </a>
              ),
            )}
          </nav>
        </div>
      )}
    </header>
  );
}